import { useQuery, useQueryClient } from "react-query";
import { JobHttpService } from "../service";

/**
 * A custom React hook for fetching and paginating schedules.
 * @returns {{
 *   data: any,
 *   isLoading: boolean,
 *   isError: boolean,
 * }}
 */
function UseScheduleList() {
    const queryClient = useQueryClient();

    const {
        data,
        isLoading,
        isError,
        refetch,
    } = useQuery(
        ["schedules_list"],
        () => {
            return JobHttpService.loadSchedules()
        },
        {
            onSuccess: (data) => {
                // console.log(data);
            }
        }
    );

    const removeItemFromList = (scheduleId) => {
        queryClient.setQueryData(["schedules_list"], oldData => ({
            ...oldData,
            results: oldData.results.filter(schedule => schedule.id !== scheduleId)
        }));
    };

    return { data, isLoading, isError, removeItemFromList, refetch };
}

export default UseScheduleList;

